import { render, staticRenderFns } from "./OpenTag.vue?vue&type=template&id=3dffed90&scoped=true"
import script from "./OpenTag.vue?vue&type=script&lang=js"
export * from "./OpenTag.vue?vue&type=script&lang=js"
import style0 from "./OpenTag.vue?vue&type=style&index=0&id=3dffed90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dffed90",
  null
  
)

export default component.exports